import { KeyValue } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CmCreqUploadService } from '../creq-upload.service';

@Component({
    selector: 'cm-selection-list',
    templateUrl: './selection-list.component.html',
    styleUrls: ['./selection-list.component.scss'],
    standalone: false
})
export class CmSelectionListComponent implements OnInit {
	maps$: Observable<KeyValue<string, string>[]>;
	constructor(private readonly uploadService: CmCreqUploadService) {}

	ngOnInit() {
		this.maps$ = this.uploadService.maps$;
	}
}
